function o(n,r,e){[n[r],n[e]]=[n[e],n[r]]}export{o as a};
